module.exports = __webpack_public_path__ + "media/src/signin/clever_icon-442de1f31df8ece198f9993fc7bd6e37.png";